"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PeriodPicker_1 = require("./PeriodPicker");
exports.PERIODS = {
    "Previous period": "previous_period",
    "Previous month": "previous_month",
    "Previous year": "previous_year",
    "Custom": "custom"
};
exports.PeriodsList = (function (list) { return Object.keys(list).map(function (key) { return ({ label: key, value: list[key] }); }); })(exports.PERIODS);
var PeriodPicker = PeriodPicker_1.default(exports.PeriodsList);
exports.PeriodPicker = PeriodPicker;
exports.default = PeriodPicker;
